import { H1, Image, Span, Strong, TypeWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import handRightImage from '../../../../../../images/hand-right.svg';
import styles from './styles.module.sass';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  text-align: center;
`;

const StyledTypeWrapper = styled(TypeWrapper)`
  margin: 0 auto;
  max-width: 44.25rem;
  padding: 0 1rem;
`;

const HeaderSection = () => (
  <Wrapper>
    <Image src={handRightImage.src} alt="Illustration of a hand" className={styles.image} />
    <StyledTypeWrapper variant="center">
      <H1 variant={['marginTopSpacer1', 'marginBottomSpacer9']}>Choosable extras</H1>
      <Span>
        Prefer to choose the extras you know you’ll need? With our choosable range you can{' '}
        <Strong>customise your extras around your lifestyle.</Strong> Just start with the base teeth bundle and then add
        on the bundles you need, with muscle & bone, eyes, and wellbeing bundles to choose from. <br />
        Now that’s simple!
      </Span>
    </StyledTypeWrapper>
  </Wrapper>
);

export default HeaderSection;
